export default __webpack_public_path__ + "static/media/CTP_Dark_DE.2c94a716.svg";